import type { FC } from 'react';
import { Badge } from '@interstate/components/Badge';

/**
 * Badge displayed when a field is new
 */
export const NewBadge: FC = () => <Badge variant="dark">New</Badge>;
